export const CompanyNameField = ({ data }: { data: any }) => {
    return <span>{data.name}</span>;
};
